// ============================================
// NATURALS BLESSING — THEME.JS
// Additional interactive functionality
// ============================================

// ============================================
// STICKY ADD TO CART — Show after scrolling past ATC
// ============================================
(function() {
  var stickyAtc = document.getElementById('sticky-atc');
  var atcSection = document.getElementById('product-atc-section');

  if (!stickyAtc || !atcSection) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        stickyAtc.classList.add('is-visible');
      } else {
        stickyAtc.classList.remove('is-visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(atcSection);
})();

// ============================================
// ANNOUNCEMENT BAR — Rotating Messages
// ============================================
(function() {
  var messages = document.querySelectorAll('.announcement-bar__message');
  if (messages.length < 2) return;

  var current = 0;
  setInterval(function() {
    messages[current].style.display = 'none';
    current = (current + 1) % messages.length;
    messages[current].style.display = 'block';
  }, 4000);
})();

function showCartNotification(productTitle) {
  // Cart drawer disabled — redirect to /cart handles confirmation
}

function updateCartCount() {
  fetch('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    bubbles.forEach(function(b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  });
}

// ============================================
// SCROLL ANIMATIONS
// ============================================
(function() {
  var animateEls = document.querySelectorAll('[data-animate]');
  if (!animateEls.length) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-animated');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  animateEls.forEach(function(el) { observer.observe(el); });
})();

// ============================================
// HEADER — Scroll behavior (add shadow on scroll)
// ============================================
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 20) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
})();

// ============================================
// PRODUCT IMAGE GALLERY — Thumbnail click
// ============================================
(function() {
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;

    var mainImg = document.getElementById('product-main-image');
    if (!mainImg) return;

    mainImg.src = thumb.dataset.src;
    if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;

    document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });
})();

// ============================================
// VARIANT SELECTOR — Update price, availability, and hidden input on variant change
// ============================================
(function() {
  // Store all variants from Shopify (injected via product-main.liquid)
  var productVariants = window.productVariants || [];

  // Track currently selected options
  var selectedOptions = {};

  // Initialize from currently active buttons
  document.querySelectorAll('.variant-btn').forEach(function(btn) {
    if (btn.style.borderColor === 'rgb(45, 106, 79)' || btn.dataset.selected === 'true') {
      selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
    }
  });

  document.addEventListener('click', function(e) {
    var variantBtn = e.target.closest('.variant-btn');
    if (!variantBtn) return;

    var position = variantBtn.dataset.optionPosition;
    var value = variantBtn.dataset.optionValue;

    // Update selected options
    selectedOptions[position] = value;

    // Update active state for this option group
    var group = variantBtn.closest('div[style]');
    if (group) {
      group.querySelectorAll('.variant-btn').forEach(function(b) {
        b.style.borderColor = '#E8E0D5';
        b.style.background = '#FFFFFF';
        b.style.color = '#1A1A1A';
      });
      variantBtn.style.borderColor = '#1E5C3A';
      variantBtn.style.background = '#F0FFF4';
      variantBtn.style.color = '#1E5C3A';
    }

    // Update the option label text (e.g. "Size: 20pk" → "Size: 60pk")
    var labelById = document.getElementById('variant-label-' + position);
    var labelEl = labelById || (variantBtn.closest('.form-group') && variantBtn.closest('.form-group').querySelector('.form-label strong'));
    if (labelEl) {
      labelEl.textContent = value;
    }

    // Find the matching variant
    var matchedVariant = null;
    for (var i = 0; i < productVariants.length; i++) {
      var v = productVariants[i];
      var match = true;
      for (var pos in selectedOptions) {
        var optIndex = parseInt(pos) - 1;
        if (v.options && v.options[optIndex] !== selectedOptions[pos]) {
          match = false;
          break;
        }
      }
      if (match) { matchedVariant = v; break; }
    }

    if (!matchedVariant) return;

    // Update hidden variant ID input
    var variantInput = document.getElementById('variant-id-input');
    if (variantInput) variantInput.value = matchedVariant.id;

    // Update price display
    var priceEl = document.querySelector('.product-info__price-current');
    var compareEl = document.querySelector('.product-info__price-compare');
    var savingsEl = document.querySelector('.product-info__price-savings');
    var bnplEl = document.querySelector('.product-info__bnpl');

    if (priceEl) {
      var price = (matchedVariant.price / 100).toFixed(2);
      priceEl.textContent = '$' + price;
    }
    if (compareEl && matchedVariant.compare_at_price > matchedVariant.price) {
      compareEl.textContent = '$' + (matchedVariant.compare_at_price / 100).toFixed(2);
      compareEl.style.display = 'inline';
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }
    if (savingsEl) {
      if (matchedVariant.compare_at_price > matchedVariant.price) {
        var savings = ((matchedVariant.compare_at_price - matchedVariant.price) / 100).toFixed(2);
        savingsEl.textContent = 'Save $' + savings;
        savingsEl.style.display = 'inline';
      } else {
        savingsEl.style.display = 'none';
      }
    }
    if (bnplEl) {
      var bnplPrice = (matchedVariant.price / 400).toFixed(2);
      bnplEl.innerHTML = 'or <strong>4 interest-free payments of $' + bnplPrice + '</strong> with Afterpay';
    }

    // Update ATC button availability
    var atcBtn = document.getElementById('add-to-cart-btn');
    var stickyBtn = document.querySelector('.sticky-atc__btn');
    if (atcBtn) {
      if (matchedVariant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = '🛒 Add to Cart';
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }
    }
    if (stickyBtn) {
      stickyBtn.disabled = !matchedVariant.available;
    }

    // Update sticky ATC price
    var stickyPrice = document.querySelector('.sticky-atc__price');
    if (stickyPrice) {
      stickyPrice.textContent = '$' + (matchedVariant.price / 100).toFixed(2);
    }
  });
})();
// ADD TO CART handler moved to product-main.liquid (single handler to prevent double-add)